import React, { Fragment } from 'react';
import { CommonDropdown } from "./CommonDropdown";

const DropdownStaticSchoolYear = ( { control, name, rules, placeHolder, isSearchable, isClearable, isMulti, readOnly, validate } ) =>
{
    const items = [
        { value: 14, label: 'Nursery'},
        { value: 15, label: 'Reception'},
        { value: 17, label: 'Early Years'},
        { value: 1, label: 'Year 1'},
        { value: 2, label: 'Year 2'},
        { value: 3, label: 'Year 3'},
        { value: 4, label: 'Year 4'},
        { value: 5, label: 'Year 5'},
        { value: 6, label: 'Year 6'},
        { value: 7, label: 'Year 7'},
        { value: 8, label: 'Year 8'},
        { value: 9, label: 'Year 9'},
        { value: 10, label: 'Year 10'},
        { value: 11, label: 'Year 11'},
        { value: 12, label: 'Year 12'},
        { value: 13, label: 'Year 13'}
    ];

    return (
        <CommonDropdown key={name} items={items} control={control} name={name} rules={rules} placeholder={placeHolder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} />
    )
}

export default DropdownStaticSchoolYear;
